import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import styles from './ShareLg.module.scss';
import { getShareUrls } from 'utils/link-generator-utils';

import { injectIntl } from 'react-intl';
import messages from './ShareLg.intl';

@injectIntl
export default class ShareLg extends Component {
  socialMediaUrls = getShareUrls(window.location.href);

  static defaultProps = {
    className: ''
  };

  render() {
    const { className } = this.props;
    const { socialMediaUrls } = this;
    return (
      <div className={`${styles.Share} ${className}`}>
        <div div={styles.TittleWrapper}>
          <p className={styles.Tittle}>
            {this.props.intl.formatMessage(messages.shareInfo)}
          </p>
        </div>
        <div className={styles.ShareIcons}>
          <a
            href={socialMediaUrls.facebook}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className={styles.IconWrapper}
          >
            <FontAwesomeIcon
              icon={['fab', 'facebook-f']}
              size="lg"
              className={styles.Icon}
            />
          </a>
          <a
            href={socialMediaUrls.twitter}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className={styles.IconWrapper}
          >
            <FontAwesomeIcon
              icon={['fab', 'twitter']}
              size="lg"
              className={styles.Icon}
            />
          </a>
          <a
            href={socialMediaUrls.linkedin}
            target="_blank"
            rel="noopener noreferrer nofollow"
            className={styles.IconWrapper}
          >
            <FontAwesomeIcon
              icon={['fab', 'linkedin-in']}
              size="lg"
              className={styles.Icon}
            />
          </a>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/ShareLg/ShareLg.js